import { render, staticRenderFns } from "./quoterLimitPriceConfig.vue?vue&type=template&id=77652bda&scoped=true&"
import script from "./quoterLimitPriceConfig.vue?vue&type=script&lang=js&"
export * from "./quoterLimitPriceConfig.vue?vue&type=script&lang=js&"
import style0 from "./quoterLimitPriceConfig.vue?vue&type=style&index=0&id=77652bda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77652bda",
  null
  
)

export default component.exports